// src/store/yachtReducer.ts
import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { getYachtInfo } from "../utils/boatApi";

// Initial state (with all `any`)
const initialState = {
  yacht: null as any,
  similarBoats: [] as any[],
  loading: false,
  error: null as string | null,
};

// Async thunk using `any`
export const fetchYachtDetails = createAsyncThunk<any, any>(
  "search/fetchYachtDetails",
  async (payload: any, { rejectWithValue }) => {
    try {
      const yachtInfo: any = await getYachtInfo(payload);
      if (!yachtInfo) return rejectWithValue("No yacht information found");
      return yachtInfo;
    } catch (error) {
      return rejectWithValue("Failed to fetch yacht details");
    }
  }
);

// Slice
const yachtReducer = createSlice({
  name: "search",
  initialState,
  reducers: {
    clearYachtDetails: (state) => {
      state.yacht = null;
      state.similarBoats = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchYachtDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchYachtDetails.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.yacht = action.payload?.yacht || null;
          state.similarBoats = action.payload?.similar_yachts || [];
        }
      )
      .addCase(
        fetchYachtDetails.rejected,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.yacht = null;
          state.error =
            (action.payload as string) || "Failed to fetch yacht details";
        }
      );
  },
});

export const { clearYachtDetails } = yachtReducer.actions;
export default yachtReducer.reducer;
